import { render, staticRenderFns } from "./VaColorPickerInput.vue?vue&type=template&id=228df2f0&"
import script from "./VaColorPickerInput.vue?vue&type=script&lang=js&"
export * from "./VaColorPickerInput.vue?vue&type=script&lang=js&"
import style0 from "./VaColorPickerInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports